var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"code",on:{"click":function($event){return _vm.getCode()}}},[_vm._v(_vm._s(_vm.codeTxt))])
}
var staticRenderFns = []

export { render, staticRenderFns }